import { useCallback } from 'react';

import { COPY_EMPTY, esCopy, useEsCopy } from './EsCopy';
import { useEsTranslationsFlag } from './EsFlags';

/*
 * A screen's strings: t( key, literal, vars ) answers the copykey in the reader's locale from
 * the copy store (EsCopy), else the literal the call site wrote, else the key.
 *
 * The literal is today's English, which is what keeps the flag honest: rolloutEsTranslations off
 * answers it without a request, as the page read before copykeys. Crafter's string bundles are
 * no longer read: esback's database is the one source of a string, and Crafter keeps pages,
 * the nav, and the footer.
 */
export function useEsStrings() {
    const aOn = useEsTranslationsFlag();
    const aCopy = useEsCopy();

    return useCallback( ( pKey, pLiteral, pVars ) => esCopy( pKey, pLiteral, pVars, aOn ? aCopy : COPY_EMPTY ),
        [ aOn, aCopy ] );
}

/**
 * t() for code with no hook to call -- an exported helper a test calls bare: the literal, filled,
 * never the bundle. A helper takes t as its last argument with this as the default, so a screen
 * passes its own t and reads the reader's locale.
 */
export const esLiteral = ( pKey, pLiteral, pVars ) => esCopy( pKey, pLiteral, pVars, COPY_EMPTY );
